var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHouseIcon = function SvgHouseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "house_icon_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M.5.5h79V47H.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#house_icon_svg__b)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.619 2.399h.09l21.136.113h.527v3.946h-.815v27.414h.05a1.496 1.496 0 0 1 1.265.698 1.56 1.56 0 0 1 .993.898 1.541 1.541 0 0 1-.078 1.332 1.49 1.49 0 0 1-.498 1.61 1.512 1.512 0 0 1-.53.272c-.086.166-.21.31-.36.42v5.023h-1.581v-1.073h-2.622v.724H41.59v-.728h-5.126v1.426H18.027v-5.91h.484v-.118c.001-.46.137-.91.392-1.293a2.364 2.364 0 0 1 1.043-.867v-9.345h-1.392v-6.909h1.382V12.7l-1.207.396-.702.234V9.332l.351-.12 20.158-6.785.083-.028Zm21.223.639L45.75 2.963l14.092.075ZM18.564 12.6l1.375-.463-1.375.463Zm.516 13.817v-5.861 5.87-.01Zm41.221 8.28-.028-.03.028.03Zm.206.336Zm.715.39Zm.098 1.817Zm-.165.539.017-.026c.008-.009-.01.017-.017.026ZM38.535 1.875l-.085.028-.084.028-20.139 6.784-.351.12-.351.121v5.105l.702-.234.702-.235.51-.175v6.091h-1.412v7.965h1.382v8.5a2.879 2.879 0 0 0-1.405 2.077H17.5v6.948h19.491v-1.426h4.08v.728H56.73v-.728h1.561v1.077h2.634v-5.307c.068-.07.131-.146.188-.226a2.05 2.05 0 0 0 .918-.746 1.987 1.987 0 0 0 .313-1.51 2.063 2.063 0 0 0-.453-2.275 2.087 2.087 0 0 0-.683-.45 2.04 2.04 0 0 0-1.124-.73V6.98h.815V1.997h-1.054L38.71 1.875h-.175Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.863 5.131v.424l-18.397 4.681v32.29H59.023V5.395l-20.16-.264Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m38.863 5.131 20.16.264v37.131H20.466v-32.29l18.397-4.68V5.13Zm-.527-.524v.549l-18 4.576-.397.1V43.05H59.55V4.876h-.527l-20.155-.269h-.532Z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.973 36.936H20.417v5.592h11.556v-5.592Z",
    fill: "#E1C496"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.974 36.936v5.587H20.417v-5.587h11.557Zm.527-.524H19.89v6.635H32.5v-6.635Z",
    fill: "#000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.912 42.526H32.05V8.456l6.862-2.836v36.906Z",
    fill: "#8B3828"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.912 5.62v36.906H32.05V8.456l6.862-2.836Zm.527-.784-.73.3-6.861 2.836-.325.134V43.05h7.916V4.836Z",
    fill: "#000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.025 25.97H39.432v.447h19.593v-.447Z",
    fill: "#E1C496"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.025 25.968v.447H39.432v-.447h19.593Zm.527-.524H38.905v1.495h20.647v-1.495Z",
    fill: "#000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.775 15.505h-2.024v3.144h2.024v-3.144Z",
    fill: "#C9FFFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.775 15.505v3.143h-2.024v-3.143h2.024Zm.527-.524h-3.078v4.19h3.078v-4.19Z",
    fill: "#000"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.775 31.106h-2.024v3.145h2.024v-3.145Z",
    fill: "#C9FFFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.775 31.106v3.143h-2.024v-3.143h2.024Zm.527-.524h-3.078v4.19h3.078v-4.19Z",
    fill: "#000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.964 15.505h-5.342v6.568h5.342v-6.568Z",
    fill: "#C9FFFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.967 15.505v6.57h-5.345v-6.57h5.345Zm.527-.524h-6.399V22.6h6.4V14.98Z",
    fill: "#000"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.48 29.62H22.37v6.76h9.108v-6.76Z",
    fill: "#C9FFFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.48 29.62v6.76h-9.107v-6.76h9.106Zm.526-.523h-10.16v7.807h10.16v-7.807Z",
    fill: "#000"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.918 13.585h-4.211v6.095h4.21v-6.095Z",
    fill: "#C9FFFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M48.918 13.585v6.098h-4.215v-6.098h4.215Zm.526-.524h-5.267v7.146h5.267V13.06Z",
    fill: "#000"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M53.244 13.585h-4.21v6.095h4.21v-6.095Z",
    fill: "#C9FFFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M53.244 13.585v6.098H49.03v-6.098h4.214Zm.527-.524h-5.268v7.146h5.268V13.06Z",
    fill: "#000"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.407 37.334c-.278 0-.545.106-.746.297a1.082 1.082 0 0 0-.831-.608 1.093 1.093 0 0 0-.967.356 1.346 1.346 0 0 0-1.826-.325 1.233 1.233 0 0 0-1.667-.02 1.232 1.232 0 0 0-1.815.632 1.233 1.233 0 0 0-1.653-.06 1.143 1.143 0 0 0-1.183-.466 1.147 1.147 0 0 0-.41.176 1.834 1.834 0 0 0-2.117-.572 1.83 1.83 0 0 0-.886.737 1.814 1.814 0 0 0 .193 2.173 1.836 1.836 0 0 0 2.15.433c.358-.168.651-.447.836-.794.15.067.31.102.474.103.248.001.489-.078.687-.225a1.227 1.227 0 0 0 1.172.567 1.234 1.234 0 0 0 1.026-.8 1.233 1.233 0 0 0 1.688.039 1.234 1.234 0 0 0 1.218.052 1.341 1.341 0 0 0 1.121.468 1.347 1.347 0 0 0 1.041-.625 1.092 1.092 0 0 0 1.514.016 1.084 1.084 0 0 0 .918.613 1.095 1.095 0 0 0 .984-.504 1.078 1.078 0 0 0-.366-1.509 1.094 1.094 0 0 0-.553-.15l-.002-.004Z",
    fill: "#63FF54"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.866 36.618a1.836 1.836 0 0 1 1.444.698 1.146 1.146 0 0 1 1.592.283 1.234 1.234 0 0 1 1.653.06 1.221 1.221 0 0 1 .755-.75 1.236 1.236 0 0 1 1.06.12 1.233 1.233 0 0 1 1.667.02 1.346 1.346 0 0 1 1.826.325 1.087 1.087 0 0 1 .967-.356 1.09 1.09 0 0 1 .831.607 1.091 1.091 0 0 1 1.728.326 1.077 1.077 0 0 1-.233 1.248 1.091 1.091 0 0 1-1.73-.311 1.092 1.092 0 0 1-1.507-.013 1.339 1.339 0 0 1-1.04.625 1.35 1.35 0 0 1-1.122-.467 1.235 1.235 0 0 1-1.218-.053 1.233 1.233 0 0 1-1.688-.038 1.223 1.223 0 0 1-1.03.806 1.236 1.236 0 0 1-1.175-.576 1.144 1.144 0 0 1-1.163.126 1.829 1.829 0 0 1-1.572.968 1.844 1.844 0 0 1-1.622-.885 1.817 1.817 0 0 1 .652-2.516c.28-.162.6-.248.925-.247Zm0-.524a2.373 2.373 0 0 0-1.999 1.1 2.339 2.339 0 0 0 .635 3.164 2.369 2.369 0 0 0 3.213-.452 1.667 1.667 0 0 0 .806-.077 1.758 1.758 0 0 0 1.951.265c.209-.103.395-.246.548-.42a1.765 1.765 0 0 0 1.568-.091 1.774 1.774 0 0 0 1.045.05 1.875 1.875 0 0 0 2.388-.071 1.625 1.625 0 0 0 1.282.019 1.62 1.62 0 0 0 2.7-.873 1.597 1.597 0 0 0-.572-1.54 1.62 1.62 0 0 0-1.635-.236 1.612 1.612 0 0 0-1.882-.248 1.873 1.873 0 0 0-1.825-.24 1.764 1.764 0 0 0-1.768-.013 1.766 1.766 0 0 0-1.931.503 1.764 1.764 0 0 0-1.405.01 1.666 1.666 0 0 0-1.558-.258 2.354 2.354 0 0 0-1.56-.592Z",
    fill: "#000"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M35.93 39.088H18.555v4.864H35.93v-4.864Z",
    fill: "#CCDAC7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M35.938 39.089v4.862H18.554v-4.862h17.384Zm.526-.524H18.027v5.91h18.437v-5.91Z",
    fill: "#000"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M59.023 36.936H39.448v5.592h19.575v-5.592Z",
    fill: "#E1C496"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M59.023 36.936v5.587H39.45v-5.587h19.574Zm.527-.524H38.923v6.635H59.55v-6.635Z",
    fill: "#000"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M51.508 30.815h-5.286v11.432h5.286V30.815Z",
    fill: "#CD8743"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M51.508 30.815v11.432h-5.286V30.815h5.286Zm.526-.524h-6.339v12.48h6.34V30.29Z",
    fill: "#000"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M49.394 32.77h-.928v9.477h.928V32.77Z",
    fill: "#C9FFFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M49.394 32.777v9.477h-.928v-9.477h.928Zm.526-.524h-1.98v10.525h1.98V32.253Z",
    fill: "#000"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M47.529 36.047h-.525v1.908h.525v-1.908Z",
    fill: "#87624A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M47.527 36.047v1.909H47v-1.909h.527Zm.527-.524h-1.58v2.956h1.58v-2.956Z",
    fill: "#000"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M55.67 41.409H42.116v1.845h13.552V41.41Z",
    fill: "#CCDAC7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M55.67 41.409v1.843H42.116V41.41h13.552Zm.526-.524H41.59v2.891h14.606v-2.891Z",
    fill: "#000"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M59.864 37.512h-.526V43.6h.526v-6.088Z",
    fill: "#AE5E1F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M59.864 37.512v6.09h-.526v-6.09h.526Zm.527-.524h-1.58v7.137h1.58v-7.137Z",
    fill: "#000"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M61.446 36.057c0-.256-.097-.503-.27-.692a1.035 1.035 0 0 0-.67-.329.953.953 0 0 0-.878-.64.962.962 0 0 0-.914.586 1.128 1.128 0 0 0-.787.704 1.112 1.112 0 0 0 .148 1.042 1.141 1.141 0 0 0 .182 1.267c.192.21.455.342.74.37a.699.699 0 0 0 .737.467.704.704 0 0 0 .624-.608.985.985 0 0 0 .84-.502.972.972 0 0 0-.017-.975c.172-.19.266-.435.265-.69Z",
    fill: "#57A752"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6 34.395a.963.963 0 0 1 .907.641 1.034 1.034 0 0 1 .869.646 1.019 1.019 0 0 1-.195 1.062.972.972 0 0 1-.336 1.337.985.985 0 0 1-.487.14.697.697 0 0 1-.624.608.705.705 0 0 1-.737-.467 1.155 1.155 0 0 1-.74-.371 1.141 1.141 0 0 1-.182-1.267 1.116 1.116 0 0 1 .64-1.745.957.957 0 0 1 .877-.587l.009.003Zm-.008-.527a1.488 1.488 0 0 0-1.252.681 1.651 1.651 0 0 0-.906.928 1.635 1.635 0 0 0 .051 1.293 1.654 1.654 0 0 0 .28 1.459c.222.29.534.5.888.596a1.226 1.226 0 0 0 1.094.523 1.234 1.234 0 0 0 1.013-.666 1.509 1.509 0 0 0 .912-.727 1.49 1.49 0 0 0 .115-1.155 1.542 1.542 0 0 0-.318-1.89 1.56 1.56 0 0 0-.597-.336 1.486 1.486 0 0 0-1.264-.699l-.016-.007Z",
    fill: "#000"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m59.842 3.038-21.137-.114-20.14 6.783V12.6l20.14-6.785 21.137.116V3.038Z",
    fill: "#D70F17"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m38.705 2.922 21.137.114V5.93l-21.137-.116-20.14 6.785V9.707l20.14-6.785Zm-.086-.523-.083.028-20.14 6.78-.352.121v3.998l.703-.234L38.79 6.341l21.047.113h.527V2.517h-.527L38.708 2.4h-.089Z",
    fill: "#000"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M31.48 20.547H19.085v5.87H31.48v-5.87Z",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M31.48 20.556v5.87h-12.4v-5.87h12.4Zm.526-.524H18.554v6.917h13.452v-6.917Z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.902 25.97h-6.778v.447h6.778v-.447Z",
    fill: "#A26E3E",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.903 25.968v.447h-6.78v-.447h6.78Zm.527-.524h-7.833v1.495h7.833v-1.495Z",
    fill: "#000",
    style: {
      mixBlendMode: "multiply"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "house_icon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(17.5 1.875)",
    d: "M0 0h45v43.125H0z"
  })))));
};

export default SvgHouseIcon;